export default __webpack_public_path__ + "static/media/game-of-life.ec7a1eb7.png";